// Copyright 1999-2026. WebPros International GmbH. All rights reserved.
/* eslint-disable react/jsx-max-depth */

import classNames from 'classnames';
import { api, prepareUrl, createComponent, Locale } from 'jsw';
import JswComponent from '../../jsw/JswComponent';
import pageData, { usePageData } from 'helpers/pageData';
import LicenseLimitsMessage from './LicenseLimitsMessage';
import SafeHtml from 'components/common/SafeHtml';

const mapping = {
    'msg-license-limits': LicenseLimitsMessage,
};

const StatusMessages = () => {
    const { status = [] } = usePageData();

    const handleCloseMessage = message => {
        if (message.hideUrl) {
            api.post(prepareUrl(message.hideUrl));
        }
        pageData({
            ...pageData(),
            status: status.filter((_, key) => message.key !== key),
        });
    };

    const renderMessage = message => {
        const {
            componentType,
            status,
            content,
            title = Locale.getSection('components.status').lmsg(status),
            class: className,
            ...other
        } = message;

        if (componentType) {
            return (
                <JswComponent>
                    {() => createComponent({
                        componentType,
                        title,
                        type: status,
                        message: content,
                        attrs: {
                            'data-rendered-by-react': 'true',
                        },
                        ...other,
                    })}
                </JswComponent>
            );
        }

        const Component = mapping[className];
        if (Component) {
            return (
                <Component
                    {...message}
                    data-rendered-by-react
                />);
        }

        const {
            key,
            id,
            source,
            hideUrl,
        } = message;

        return (
            <div
                key={key}
                id={id}
                className={classNames('msg-box', `msg-${status}`, className)}
                data-source={source}
                data-rendered-by-react
            >
                <div>
                    <div>
                        <div>
                            <div>
                                <div>
                                    <div className="msg-content">
                                        {hideUrl ? (
                                            <span
                                                className="close"
                                                role="button"
                                                tabIndex={0}
                                                onClick={() => handleCloseMessage(message)}
                                                onKeyDown={e => {
                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                        e.preventDefault();
                                                        handleCloseMessage(message);
                                                    }
                                                }}
                                            />
                                        ) : null}
                                        {title ? (
                                            <span className="title">
                                                {title}{': '}
                                            </span>
                                        ) : null}
                                        <span>
                                            <SafeHtml html={content} />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return status.map((message, key) => renderMessage({ key, ...message }));
};

export default StatusMessages;
